import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from '../../auth/login';
import PasswordRecovery from '../../auth/password-recovery';
import ResetPassword from '../../auth/reset-password';
import '../../../style/css/style.css';
import PagesAuthHeader from '../../../feature-module/frontend/pages/authentication/common/header';

const AuthRoutes = () => {
  return (
    <>
      <PagesAuthHeader />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/password-recovery" element={<PasswordRecovery />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </>
  );
};

export default AuthRoutes;